import { Component, OnInit, Input } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from '../../service/auth/auth.service';
import { ConfigService } from '../../service/config/config.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { FormattingService } from '../../service/formatting/formatting.service';


@Component({
  selector: 'app-laaneoversigt',
  templateUrl: './laaneoversigt.page.html',
  styleUrls: ['./laaneoversigt.page.scss'],
})
export class LaaneoversigtPage  {

  private loans: any[] = [];

  private interest_period: string;
  private interest_total: string;
  private instalments_period: string;
  private instalments_total: string;
  private debt_total: string;

  private start_date: string;
  private expiry_date: string;
  private displayDate: string;


  private canBeClosed: boolean = false;

  private status: string = 'notsaved';

  @Input() modalCtrl: ModalController;

  constructor(private auth: AuthService, private http: HttpClient, private config: ConfigService, private alertCtrl: AlertController, private datePipe: DatePipe, private formattingService: FormattingService) { }

  formatDate(dateStr: string): string {
    let date = this.datePipe.transform(dateStr, 'dd.MM.yy');
    return `${date}`;
  }


  

  ngOnInit() {
    this.getLoans();
  }

  public async getLoans(): Promise<any>{
    if(this.auth.userProfile){
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

      const options = {
        headers: headers
      };


      const url = `${this.config.basePath}/api/farmers/${this.auth.userProfile.id}?filter=${encodeURIComponent(JSON.stringify({ include: 'loans' }))}`;
      this.http.get<any[]>(url, options)
        .subscribe((data)=>{
          this.loans = data['loans'];

                          // Initialize sums
                          let accumulatedInterestsSum = 0;
                          let totalInterestsSum = 0;
                          let settled_instalments = 0;
                          let settledInstalmentsTotalSum = 0;
                          let residualDebtSum = 0;
                          let amountSum = 0;
          
                          // Calculate sums
                          this.loans.forEach(loan => {
                              let loanStartDate = new Date(loan.start_date);
                              let loanExpiryDate = new Date(loan.expiry_date);

                              // Assign the earliest start_date
                              if (!this.start_date || loanStartDate < new Date(this.start_date)) {
                                  this.start_date = loan.start_date;
                              }

                              // Assign the latest expiry_date
                              if (!this.expiry_date || loanExpiryDate > new Date(this.expiry_date)) {
                                  this.expiry_date = loan.expiry_date;
                              }

                              let tmpDateObj = {"start_date": this.start_date, "expiry_date": this.expiry_date}
                              this.displayDate = this.formattingService.formatToFromData(tmpDateObj);

                              accumulatedInterestsSum += parseFloat(loan.accumulated_interests);
                              totalInterestsSum += parseFloat(loan.total_interests);
                              settled_instalments += parseFloat(loan.settled_instalments);
                              settledInstalmentsTotalSum += parseFloat(loan.settled_instalments_total);
                              residualDebtSum += parseFloat(loan.residual_debt);
                              amountSum += parseFloat(loan.amount );
                              //console.log('A', parseFloat(loan.accumulated_interests))
                          });

                          this.interest_period = this.formattingService.formatNumber(accumulatedInterestsSum, true);
          
                          this.interest_total = this.formattingService.formatNumber(totalInterestsSum, true);
                          //this.settled_instalments = settled_instalments.toFixed(2);
                          this.instalments_total = this.formattingService.formatNumber(settledInstalmentsTotalSum, true);
                          this.debt_total = this.formattingService.formatNumber(residualDebtSum, true);
                          this.instalments_period = this.formattingService.formatNumber(settled_instalments, true);
        });
    }
  }
}